<script setup lang="ts">
import { useQuery } from '@tanstack/vue-query'
import { Download } from 'lucide-vue-next'
import { CkAlert, CkTable } from '@ck/ui'
import { reportsApi } from '@ck/api-client'
import { formatDate } from '@ck/domain'

const reportsQuery = useQuery({ queryKey: ['reports'], queryFn: () => reportsApi.list() })

const columns = [
  { key: 'code', label: 'Código', width: '130px' },
  { key: 'vehicle', label: 'Veículo', width: '1.4fr' },
  { key: 'date', label: 'Data', width: '110px' },
  { key: 'status', label: 'Status', width: '110px' },
  { key: 'actions', label: '', width: '80px', align: 'right' as const }
]

const statusLabel: Record<string, string> = { queued: 'Na fila', ready: 'Pronto' }
async function download(id: string) {
  const blob = await reportsApi.download(id)
  const url = URL.createObjectURL(blob)
  window.open(url, '_blank')
  setTimeout(() => URL.revokeObjectURL(url), 30000)
}
</script>

<template>
  <div>
    <div class="page-head"><h1>Relatórios</h1><p>Relatórios gerados</p></div>
    <CkAlert v-if="reportsQuery.isError.value" tone="error" class="alert">Não foi possível carregar os relatórios.</CkAlert>
    <CkTable
      :columns="columns"
      :rows="reportsQuery.data.value?.items ?? []"
      :row-key="(row) => row.id"
      empty-message="Nenhum relatório gerado ainda."
    >
      <template #default="{ item }">
        <span class="ck-code">REL-{{ item.workOrderNumber }}-r{{ item.revision }}</span>
        <span>{{ item.vehicleBrand }} {{ item.vehicleModel }}</span>
        <span class="ck-code">{{ formatDate(item.requestedAt) }}</span>
        <span class="chip" :class="`chip--${item.status}`">{{ statusLabel[item.status] ?? item.status }}</span>
        <button v-if="item.status === 'ready'" type="button" class="download" @click="download(item.id)"><Download :size="14"/>PDF</button>
      </template>
    </CkTable>
  </div>
</template>

<style scoped>
.page-head { margin-bottom: 20px; }
.page-head h1 { margin: 0; font-family: var(--font-display); font-size: 26px; font-weight: 800; }
.page-head p { margin: 4px 0 0; color: var(--color-text-faint); font-size: 13px; }
.alert { margin-bottom: 16px; }
.chip { padding: 3px 10px; border-radius: 99px; font-size: 11.5px; font-weight: 700; background: var(--ck-info-bg); color: var(--ck-info-text); width: fit-content; }
.chip--ready { background: var(--ck-ok-bg); color: var(--ck-ok-text); }
.download { justify-self: end; display: inline-flex; align-items: center; gap: 6px; border: 1px solid var(--color-border); border-radius: var(--radius-sm); background: transparent; color: var(--color-text); font-size: 12px; padding: 6px 10px; cursor: pointer; }
</style>
